/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ROUTES } from 'constants';

import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import WelcomePage from '../WelcomePage/WelcomePage';

import styles from './Login.module.css';

const messages = defineMessages({
  errorMessage:
    'To log in, you must specify the tenantid parameter at the end of the URL. For example, https://myconnectedproduct.ibmcloud.com/preauth?tenantid=mytenantid.',
  errorMessageMAS:
    'To log in, you must specify the tenantid parameter at the beginning of the URL. For example, https://tenantid.monitor.mashostname.',
});

const propTypes = {
  title: PropTypes.string.isRequired,
  tenantId: PropTypes.string,
  isICP: PropTypes.bool,
  docURL: PropTypes.string.isRequired,
};

const defaultProps = {
  tenantId: null,
  isICP: false,
};

const Login = ({
  title,
  location: { pathname },
  isICP,
  tenantId,
  docURL,
  intl: { formatMessage },
}) =>
  isICP ? ( // MAS Version they'll only be sent to this route in isICP if no tenant was passed
    <div className={styles.container}>
      <WelcomePage
        title={title}
        tenantId={tenantId}
        docURL={docURL}
        errorMessage={formatMessage(messages.errorMessageMAS)}
      />
    </div>
  ) : pathname === ROUTES.SIGNIN || tenantId ? ( // SaaS version
    <div className={styles.container}>
      <WelcomePage title={title} tenantId={tenantId} docURL={docURL} />
    </div>
  ) : (
    <div className={styles.container}>
      <WelcomePage
        title={title}
        tenantId={tenantId}
        docURL={docURL}
        errorMessage={formatMessage(messages.errorMessage)}
      />
    </div>
  );
Login.propTypes = propTypes;
Login.defaultProps = defaultProps;

export default injectIntl(Login);
